import { useGetProjectsQuery } from "../../Api/api";
import { useEffect, useState } from "react";
import "./projects.css";
import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Project from "./ProSample";
import img1 from "../../images/datebus.png";
import meraki from "../../images/meraki.png";
import texas from "../../images/texas.png";

const Projects = () => {
  const { data: projects, isFetching } = useGetProjectsQuery();
  const img_300 = "http://drive.google.com/uc?id=";

  return (
    <div className="mywork " id="work">
      <div className="mywork-title">
        <h2>Check Out My Reacet Projects</h2>

        <h3>My Work</h3>
      </div>
      <div className="project-row">
        <OwlCarousel className="owl-theme">
          <Project
            imgSrc={img1}
            title="Date A Bus - A Unique Dating Concept"
            description="Date A Bus is a one-man owned business that, with its new developed concept,"
            liveDemoLink="https://dateabus.com/"
            author="Codginator | PHP"
          />

          {/* texasnet.com */}

          <Project
            imgSrc={texas}
            title="TexasiNet Focus "
            description="TexasiNet provide industry-leading technologies allowing your company to focus on business growth, profitability and operational excellence."
            liveDemoLink="https://www.texasinet.com/" 
            author="Laravel | Reactjs"
          />
          {/* meraki eshop  */}

          <Project
            imgSrc={meraki}
            title="Meeraki | A house of Meeraki"
            description="Meeraki is a fashion brand created especially for young and lively youth. It consists of a hardworking and enthusiastic group of people."
            liveDemoLink="https://meeraki.com/"
            author="Laravel | Reactjs ,Next js"
          />
        </OwlCarousel>
      </div>
    </div>
  );
};

export default Projects;
